module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_21-5e9726021ad467cc81eedbbb3dbc5258.jpg";